import React from "react";
import Typography from "@mui/material/Typography";

import { SectionPageIntroProps } from "src/library/types/types";

export default function SectionHeader(props: SectionPageIntroProps) {
  const { text } = props;

  return (
    <Typography
      variant="h4"
      component="p"
      fontWeight="fontWeightBold"
      color="text.light"
      textAlign="left"
      py={1}
    >
      {text}
    </Typography>
  );
}
